import { addDoc, collection, Timestamp } from 'firebase/firestore';
import { firestore } from './client';
import { auth } from './client';

export interface PaymentError {
  type: 'non_critical' | 'critical';
  cause: string;
  message: string;
  userId?: string;
  userEmail?: string;
  timestamp: Date;
  context?: {
    page: string;
    subscriptionPlan?: string;
    amount?: number;
    [key: string]: any;
  };
}

const ERRORS_COLLECTION = 'payment_errors';
let hasWarnedPaymentErrorPermission = false;

/**
 * Registra um erro de pagamento no Firestore
 */
export const logPaymentError = async (
  error: Omit<PaymentError, 'timestamp' | 'userId' | 'userEmail'>,
): Promise<void> => {
  try {
    const user = auth.currentUser;

    const errorData: PaymentError = {
      ...error,
      timestamp: new Date(),
      userId: user?.uid,
      userEmail: user?.email || undefined,
    };

    await addDoc(collection(firestore, ERRORS_COLLECTION), {
      ...errorData,
      timestamp: Timestamp.fromDate(errorData.timestamp),
    });

    console.log('✅ Erro de pagamento registrado no Firestore:', {
      type: errorData.type,
      cause: errorData.cause,
      userId: errorData.userId,
    });
  } catch (logError) {
    const errorCode =
      typeof logError === 'object' && logError && 'code' in logError
        ? String(logError.code)
        : '';
    const errorMessage =
      typeof logError === 'object' && logError && 'message' in logError
        ? String(logError.message)
        : '';

    if (
      errorCode === 'permission-denied' ||
      errorMessage.includes('Missing or insufficient permissions')
    ) {
      if (!hasWarnedPaymentErrorPermission) {
        hasWarnedPaymentErrorPermission = true;
        console.warn(
          'Nao foi possivel registrar erros de pagamento no Firestore por falta de permissao.',
        );
      }
      return;
    }

    // Não queremos que erros de logging quebrem o fluxo
    console.error(
      '❌ Erro ao registrar erro de pagamento no Firestore:',
      logError,
    );
  }
};
